const KEY_B64 = process.env.REACT_APP_ENCRYPTION_KEY;
let _cachedKey = null;

async function getKey() {
  if (_cachedKey) return _cachedKey;
  const raw = Uint8Array.from(atob(KEY_B64), (c) => c.charCodeAt(0));
  _cachedKey = await crypto.subtle.importKey("raw", raw, "AES-GCM", false, ["decrypt"]);
  return _cachedKey;
}

/**
 * @param {{ encrypted: string, iv: string, tag: string }} payload
 * @returns {Promise<unknown>} Decrypted and JSON-parsed response body
 */
export async function decryptPayload({ encrypted, iv, tag }) {
  const key = await getKey();

  const ciphertextBytes = Uint8Array.from(atob(encrypted), (c) => c.charCodeAt(0));
  const tagBytes = Uint8Array.from(atob(tag), (c) => c.charCodeAt(0));
  const ivBytes = Uint8Array.from(atob(iv), (c) => c.charCodeAt(0));

  // Web Crypto AES-GCM expects ciphertext || auth-tag concatenated
  const combined = new Uint8Array(ciphertextBytes.length + tagBytes.length);
  combined.set(ciphertextBytes);
  combined.set(tagBytes, ciphertextBytes.length);

  const decrypted = await crypto.subtle.decrypt({ name: "AES-GCM", iv: ivBytes }, key, combined);
  return JSON.parse(new TextDecoder().decode(decrypted));
}

export function isEncryptedPayload(data) {
  return (
    data !== null &&
    typeof data === "object" &&
    typeof data.encrypted === "string" &&
    typeof data.iv === "string" &&
    typeof data.tag === "string"
  );
}
